export default __webpack_public_path__ + "static/media/1_7_hl.5d1e5dc3.png";